<template>
    <base-dialog :value="dialog" :width="420" :title="dialogTitle" @input="onInput" @close="hide">
        <plan-required-content v-if="dialog" :key="contentKey" :feature="feature" :limit-key="limitKey" :max="max"
            :notice="notice" @title="dialogTitle = $event" />
    </base-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import BaseDialog from '@/components/common/BaseDialog'
import PlanRequiredContent from '@/components/common/PlanRequiredContent'

export default {
    name: 'PlanRequiredDialog',
    components: { BaseDialog, PlanRequiredContent },
    data() {
        return {
            dialogTitle: '',
        }
    },
    computed: {
        ...mapState(['planRequired']),
        dialog(vm = this) {
            return !!vm.planRequired
        },
        feature(vm = this) {
            return vm.planRequired?.feature || null
        },
        limitKey(vm = this) {
            return vm.planRequired?.limitKey || null
        },
        max(vm = this) {
            return Number(vm.planRequired?.max || 0)
        },
        notice(vm = this) {
            return vm.planRequired?.notice || null
        },
        contentKey(vm = this) {
            return `${vm.feature || ''}|${vm.limitKey || ''}`
        },
    },
    methods: {
        ...mapMutations(['hidePlanRequired']),
        hide() {
            this.hidePlanRequired()
        },
        onInput(val) {
            if (!val) this.hide()
        },
    },
}
</script>
